/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StatusService {

    /**
     * Get API Status
     * @returns any Response with status and date
     * @throws ApiError
     */
    public static getStatus(): CancelablePromise<{
status?: string;
date?: string;
version?: string;
client?: string;
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/status',
        });
    }

}
